const dummyPosts = [
  {
    id: 1,
    title: 'Joining the Medi Community',
    content: 'Excited to join the Medi community! :tada:',
    timestamp: new Date().toISOString(),
    user: {
      first_name: 'John',
      last_name: 'Doe',
      username: 'johndoe123',
      email: 'johndoe@example.com',
      date_of_birth: '1990-05-15',
      gender: 'male',
      address: '123 Main St, Apt 4B',
      phone_number: '+254712345678',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      country: 'Kenya',
      city: 'Nairobi',
      postal_code: '00100',
      street: 'Main Street',
      country_code: '+254'
    },
    reaction_count: {
      love: 24
    },
    comments: [
      {
        id: 1,
        user: 'Jane Doe',
        content: 'Welcome to the community!',
        timestamp: new Date().toISOString()
      },
      {
        id: 2,
        user: 'Alice Johnson',
        content: 'Glad to have you here!',
        timestamp: new Date().toISOString()
      }
    ]
  },
  {
    id: 2,
    title: 'Health Tip of the Day',
    content: 'Health is wealth. Stay hydrated! :droplet:',
    timestamp: new Date().toISOString(),
    user: {
      first_name: 'John',
      last_name: 'Doe',
      username: 'johndoe123',
      email: 'johndoe@example.com',
      date_of_birth: '1990-05-15',
      gender: 'male',
      address: '123 Main St, Apt 4B',
      phone_number: '+254712345678',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      country: 'Kenya',
      city: 'Nairobi',
      postal_code: '00100',
      street: 'Main Street',
      country_code: '+254'
    },
    reaction_count: {
      love: 24
    },
    comments: []
  },
  {
    id: 3,
    title: 'Meditation App Review',
    content:
            "Has anyone tried the new meditation app? I've been using it for the past few days, and I have to say, it's been quite an interesting experience. The app offers various guided meditation sessions, ranging from quick 5-minute sessions to more in-depth 30-minute mindfulness practices. The interface is smooth, and it even has options for sleep meditation, which has helped me unwind after a long day. I'm curious to hear other people's thoughts on it—has anyone else tried it out? Any recommendations for other similar apps that are worth exploring?",
    timestamp: new Date().toISOString(),
    user: {
      first_name: 'John',
      last_name: 'Doe',
      username: 'johndoe123',
      email: 'johndoe@example.com',
      date_of_birth: '1990-05-15',
      gender: 'male',
      address: '123 Main St, Apt 4B',
      phone_number: '+254712345678',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      country: 'Kenya',
      city: 'Nairobi',
      postal_code: '00100',
      street: 'Main Street',
      country_code: '+254'
    },
    reaction_count: {
      love: 24
    },
    group: '',
    page: '',
    comments: []
  }
];
export const dummyGroups = [
  {
    id: 1,
    name: 'Health Enthusiasts',
    description: 'A group for people passionate about health and wellness.',
    adminUser: {
      id: 1,
      first_name: 'John',
      last_name: 'Doe',
      username: 'johndoe123',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    members: [
      {
        id: 1,
        first_name: 'John',
        last_name: 'Doe',
        username: 'johndoe123',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
      },
      {
        id: 2,
        first_name: 'Jane',
        last_name: 'Smith',
        username: 'janesmith',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
      }
    ]
  },
  {
    id: 2,
    name: 'Meditation Masters',
    description: 'Join us to share and learn about meditation techniques.',
    adminUser: {
      id: 3,
      first_name: 'Alice',
      last_name: 'Brown',
      username: 'aliceb',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
    },
    members: [
      {
        id: 3,
        first_name: 'Alice',
        last_name: 'Brown',
        username: 'aliceb',
        avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
      },
      {
        id: 4,
        first_name: 'Bob',
        last_name: 'Johnson',
        username: 'bobjohnson',
        avatar: 'https://randomuser.me/api/portraits/men/45.jpg'
      },
      {
        id: 9,
        first_name: 'Charlie',
        last_name: 'Davis',
        username: 'charlied',
        avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
      }
    ]
  },
  {
    id: 3,
    name: 'Fitness Freaks',
    description: 'A community for fitness lovers to share tips and workouts.',
    adminUser: {
      id: 5,
      first_name: 'Charlie',
      last_name: 'Davis',
      username: 'charlied',
      avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
    },
    members: [
      {
        id: 5,
        first_name: 'Charlie',
        last_name: 'Davis',
        username: 'charlied',
        avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
      },
      {
        id: 6,
        first_name: 'Diana',
        last_name: 'Evans',
        username: 'dianae',
        avatar: 'https://randomuser.me/api/portraits/women/56.jpg'
      },
      {
        id: 10,
        first_name: 'Charlie',
        last_name: 'Davis',
        username: 'charlied',
        avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
      }
    ]
  }
];
// Dummy data for groups the user is already in
export const userGroups = [
  {
    id: 4,
    name: 'Yoga Lovers',
    description: 'A group for yoga enthusiasts to share tips and routines.',
    adminUser: {
      id: 7,
      first_name: 'Emily',
      last_name: 'Clark',
      username: 'emilyc',
      avatar: 'https://randomuser.me/api/portraits/women/57.jpg'
    },
    members: [
      {
        id: 7,
        first_name: 'Emily',
        last_name: 'Clark',
        username: 'emilyc',
        avatar: 'https://randomuser.me/api/portraits/women/57.jpg'
      },
      {
        id: 8,
        first_name: 'Frank',
        last_name: 'Miller',
        username: 'frankm',
        avatar: 'https://randomuser.me/api/portraits/men/58.jpg'
      }
    ]
  }
];
export default dummyPosts;
